var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.461,
    height: 132,
    viewBox: "0 0 102.461 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(-1152.509 -5441.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-outline",
    transform: "translate(1147.759 5440.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M-772.326-5881.625H-841.25a14.672,14.672,0,0,1-10.443-4.326,14.672,14.672,0,0,1-4.326-10.443v-98.462a14.67,14.67,0,0,1,4.326-10.443,14.671,14.671,0,0,1,10.443-4.326h30.383a9.867,9.867,0,0,1,2.568.342v39.72a10.694,10.694,0,0,0,10.681,10.683H-757.9a9.852,9.852,0,0,1,.34,2.559l0,0v59.921a14.673,14.673,0,0,1-4.326,10.443A14.672,14.672,0,0,1-772.326-5881.625Zm14.276-77.747-49.76-49.764a9.9,9.9,0,0,1,3.9,2.4l43.462,43.464a9.875,9.875,0,0,1,2.4,3.9Z",
    transform: "translate(862.769 6013)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 40,
    transform: "translate(1183.24 5534.162)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    y2: 40,
    transform: "translate(1203.24 5514.162)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDoc);
export default __webpack_public_path__ + "static/media/new-doc.69035aff9a9dc6204999b93ae67e1857.svg";
export { ForwardRef as ReactComponent };